import { COLORS } from "./constants";

const ACRONYMS = new Set([
  "OCPP",
  "API",
  "EV",
  "EVSE",
  "ID",
  "IP",
  "USB",
  "AC",
  "DC",
  "HTTP",
  "HTTPS",
  "URL",
  "JSON",
  "XML",
  "CSV",
  "PDF",
  "SSL",
  "TLS",
]);

export function titleCase(str) {
  return str
    .split("_")
    .join(" ")
    .split(" ")
    .map(word => {
      const upper = word.toUpperCase();
      if (ACRONYMS.has(upper)) return upper;
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
}

export function countBy(arr, keyFn) {
  const map = {};
  arr.forEach(item => {
    const key = keyFn(item);
    map[key] = (map[key] || 0) + 1;
  });
  return Object.entries(map)
    .map(([name, value]) => ({ name: titleCase(name), value }))
    .sort((a, b) => b.value - a.value);
}

export function pieOptions(title, data, colors) {
  return {
    chart: { type: "pie", height: 280, backgroundColor: "transparent" },
    title: { text: null },
    credits: { enabled: false },
    tooltip: {
      pointFormat: "<b>{point.y}</b> chargers ({point.percentage:.1f}%)",
      style: { fontSize: "13px" },
    },
    plotOptions: {
      pie: {
        innerSize: "55%",
        allowPointSelect: true,
        cursor: "pointer",
        borderRadius: 4,
        dataLabels: {
          enabled: true,
          format: "{point.percentage:.0f}%",
          distance: -25,
          style: { fontSize: "11px", fontWeight: "600", color: "#fff", textOutline: "none" },
          filter: { property: "percentage", operator: ">", value: 4 },
        },
        showInLegend: true,
      },
    },
    legend: {
      align: "center",
      verticalAlign: "bottom",
      layout: "horizontal",
      itemStyle: { fontSize: "12px", fontWeight: "500" },
    },
    series: [
      {
        name: title,
        colorByPoint: true,
        data: data.map((d, i) => ({
          name: d.name,
          y: d.value,
          color: colors ? colors[i % colors.length] : COLORS[i % COLORS.length],
        })),
      },
    ],
  };
}

export function barOptions(title, data) {
  return {
    chart: { type: "column", height: 300, backgroundColor: "transparent" },
    title: { text: null },
    credits: { enabled: false },
    xAxis: {
      categories: data.map(d => d.name),
      labels: { style: { fontSize: "11px" }, rotation: data.length > 6 ? -30 : 0 },
    },
    yAxis: { title: { text: null }, allowDecimals: false, gridLineColor: "#e5e7eb" },
    tooltip: {
      pointFormat: "<b>{point.y}</b> chargers",
      style: { fontSize: "13px" },
    },
    legend: { enabled: false },
    plotOptions: {
      column: {
        borderRadius: 5,
        colorByPoint: true,
        colors: data.map((_, i) => COLORS[i % COLORS.length]),
      },
    },
    series: [{ name: title, data: data.map(d => d.value) }],
  };
}
